import React from "react";

import { noop } from "lodash";

import {
  DetailsWrapper,
  DetailsLine,
  TextWrapper,
  DetailsTitle,
  DetailsOptional,
  DetailsText,
  CustomEditButton,
  PasswordWrapper,
  IconWrapper,
  IconButton,
  InnerTextWrapper,
  InnerTextVertical,
  LowerText,
  DetailsPassword
} from "./styled-components";
import { eyeLineHide, eyeLineShow } from "../../_static/Icons/icons";
import { optedIn, referFriend } from "../../_static/Icons/iconsDuotone";
import buildColor from "../../_static/ColorPalette";
import Icon from "../../_static/Icons";

export const EditDetails = ({
  hasBorderBottom,
  hasBorderTop,
  wrapperMarginBottom,
  wrapperOnClick,
  rows = []
}) => (
  <DetailsWrapper
    data-qa-label="edit-details-wrapper"
    hasBorderBottom={hasBorderBottom}
    hasBorderTop={hasBorderTop}
    wrapperMarginBottom={wrapperMarginBottom}
    onClick={wrapperOnClick}
  >
    {rows.map(
      ({
        title = "",
        text = "",
        isOptional = false,
        hasEdit = false,
        customEditText = "",
        qaLabel = "",
        handleEdit = noop,
        marginBottom = 4,
        isPassword = false,
        isPasswordVisible = false,
        handleShowPassword = noop,
        hasPromoIcon = false,
        hasRafIcon = false,
        lowerText = ""
      }) => {
        // For password rows
        if (text && isPassword) {
          return (
            <DetailsLine
              key={`password-${text}-${qaLabel}`}
              marginBottom={marginBottom}
            >
              <PasswordWrapper
                data-qa-label={`details-password-wrapper-${qaLabel}`}
              >
                <DetailsPassword
                  data-qa-label={`details-password-${qaLabel}`}
                  type={isPasswordVisible ? "text" : "password"}
                  value={text}
                  isPasswordVisible={isPasswordVisible}
                  disabled
                />
                <IconButton
                  onClick={handleShowPassword}
                  data-qa-label={`details-password-icon-${qaLabel}`}
                >
                  <Icon
                    icon={isPasswordVisible ? eyeLineHide : eyeLineShow}
                    size={16}
                    viewBoxSize={16}
                    color={buildColor("blue_accent", "500")}
                  />
                </IconButton>
              </PasswordWrapper>
            </DetailsLine>
          );
        }

        // When only want a row with a link
        if (!title && !text && customEditText) {
          return (
            <DetailsLine
              key={`link-${customEditText}-${qaLabel}`}
              marginBottom={marginBottom}
            >
              {hasEdit && (
                <CustomEditButton
                  data-qa-label={`details-link-edit-${qaLabel}`}
                  onClick={handleEdit}
                >
                  {customEditText}
                </CustomEditButton>
              )}
            </DetailsLine>
          );
        }

        // General rows
        if (title || text) {
          return (
            <DetailsLine
              key={`general-${title || text}-${qaLabel}`}
              marginBottom={marginBottom}
            >
              <TextWrapper data-qa-label={`details-text-${qaLabel}`}>
                {hasPromoIcon && (
                  <IconWrapper
                    data-qa-label={`promo-icon-details-text-${qaLabel}`}
                  >
                    <Icon
                      icon={optedIn}
                      size={16}
                      viewBoxSize={16}
                      color={buildColor("green", "100")}
                      stroke={buildColor("green", "500")}
                    />
                  </IconWrapper>
                )}
                {hasRafIcon && (
                  <IconWrapper
                    data-qa-label={`raf-icon-details-text-${qaLabel}`}
                  >
                    <Icon
                      icon={referFriend}
                      viewBoxSize={16}
                      color={buildColor("green", "100")}
                      stroke={buildColor("green", "500")}
                    />
                  </IconWrapper>
                )}
                <InnerTextVertical>
                  <InnerTextWrapper>
                    {title && <DetailsTitle>{title}</DetailsTitle>}
                    {isOptional && (
                      <DetailsOptional>(optional)</DetailsOptional>
                    )}
                    {text && <DetailsText>{text}</DetailsText>}
                  </InnerTextWrapper>
                  {lowerText && (
                    <LowerText data-qa-label={`lower-details-text-${qaLabel}`}>
                      {lowerText}
                    </LowerText>
                  )}
                </InnerTextVertical>
              </TextWrapper>
              {hasEdit && (
                <CustomEditButton
                  data-qa-label={`details-general-edit-${qaLabel}`}
                  onClick={handleEdit}
                >
                  {customEditText || "Edit"}
                </CustomEditButton>
              )}
            </DetailsLine>
          );
        }

        return null;
      }
    )}
  </DetailsWrapper>
);

EditDetails.defaultProps = {
  hasBorderBottom: true
};

export default React.memo(EditDetails);
